import React from 'react';
import Breadcrumbs from '../../../components/Breadcrumbs/Breadcrumbs';
import ContentPanel from "../../../components/ContentPanel/ContentPanel";
import Skeleton from "../../../components/Skeleton/Skeleton";
import ToolsWidget from "../../../components/ToolsWidget/ToolsWidget";
import store from "../../../store";
import {Helmet} from "react-helmet";

const SouthwestStandard = () => {
  return (
    <div className="wrapper">
        <Helmet>
            {
                store.getState().sitemapData.sitemap ? store.getState().sitemapData.sitemap.map((row) => {
                    return row.rowTitle === "Ship" ? row.sections.map((section) => {
                        return section.title === "Products" ? section.subsections.map((subsection) => {
                                    return subsection.title === "Southwest Standard" ? <meta name="description" content={subsection.content['seo-description']}/> : null
                                })
                                : null
                    }) : null
                }) : null
            }
        </Helmet>
      <Breadcrumbs/>
      <ContentPanel
        skeleton={<Skeleton type="MAIN_PANEL"/>}
        errorTemplate={<Skeleton type="MAIN_PANEL_ERROR"/>}
        templateUrl="./content/ship/page-components/text-block/standard-heading.html"
      />
      <ContentPanel
        skeleton={<Skeleton type="IFRAME"/>}
        errorTemplate={<Skeleton type="IFRAME_ERROR"/>}
        templateUrl="./content/ship/page-components/content-detail/standard-body-1.html"
      />
      <div className="mtl mb36">
        <ToolsWidget/>
      </div>
    </div>
  )
};

export default SouthwestStandard;



// WEBPACK FOOTER //
// ./src/pages/ship/Products/SouthwestStandard.js